import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import closeIconSrc from './close.svg'
import './style.css'

const CLOSE_DELAY_IN_MS = 250
const CLOSABLE_CLASS = 'drift-base-modal-plain-closable'


class BaseModalPlain extends Component {

	static propTypes = {
		onCloseInitiated: PropTypes.func.isRequired
	}

	state = {
		isClosing: false
	}

	onCloseOutside = ({ target }) => {
		if (target.className.includes(CLOSABLE_CLASS))
			this.initiateClose()
	}

	closeWithDelay = () => {
		setTimeout(this.props.onCloseInitiated, CLOSE_DELAY_IN_MS)
	}

	initiateClose = () => {
		this.setState({ isClosing: true }, this.closeWithDelay)
	}

	tryHandleEscapeKeyPress = ({ key }) => {
		if (key === 'Escape')
			this.initiateClose()
	}

	render() {
		const { children } = this.props
		const { isClosing } = this.state

		return (
			<div tabIndex="0"
				ref={elem => elem && elem.focus()}
				onKeyDown={this.tryHandleEscapeKeyPress}
				className={cx(
					CLOSABLE_CLASS,
					'drift-base-modal-plain',
					{ 'drift-base-modal-plain-closing': isClosing }
				)}
				onClick={this.onCloseOutside}>

				<img
					src={closeIconSrc}
					alt="close"
					className="drift-base-modal-plain-close"
					onClick={this.initiateClose}
				/>

				<div className="drift-base-modal-plain-content">
					{ children }
				</div>

			</div>
		)
	}
}

export default BaseModalPlain
